module.exports = __webpack_public_path__ + "static/media/home-background.ba8cba14.jpg";